/** Map normalized bureau names (without "Bureau" suffix) to short labels for chips. */
export function bureauChipLabel(normalizedBureau: string): string {
  const key = normalizedBureau.toLowerCase();
  if (key.includes('wireline')) return 'WCB';
  if (key.includes('engineering and technology') || /\boet\b/.test(key)) return 'OET';
  if (key.includes('media')) return 'MB';
  if (key.includes('wireless telecommunications') || key.includes('wireless telecomm')) return 'WTB';
  if (key.includes('enforcement')) return 'EB';
  if (key.includes('international')) return 'IB';
  if (key.includes('public safety')) return 'PSB';
  if (key.includes('office of economics') || key.includes('economics and analytics')) return 'OEA';
  if (key.includes('general') && key.includes('multiple')) return 'GEN';
  const words = normalizedBureau.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '—';
  if (words.length === 1) return words[0].replace(/[^a-z0-9]/gi, '').slice(0, 4).toUpperCase();
  // Initials from each word's first letter/digit — skip punctuation so names like
  // "General (Multiple Bureaus)" yield "GMB", never "G(B".
  return words
    .slice(0, 3)
    .map((w) => w.match(/[a-z0-9]/i)?.[0] ?? '')
    .join('')
    .toUpperCase();
}
